import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthenticationService } from 'src/app/authentication/authentication.service';
import { CommonComponentsModule } from 'src/app/common-components/common-components.module';
import { LoadingComponent } from 'src/app/common-components/loading/loading.component';
import { ModelHeaderComponent } from 'src/app/common-components/model-header/model-header.component';
import { CommonService } from 'src/app/services/common.service';
import { UiSpinnerService } from 'src/app/services/ui-spinner.service';
import { DialogData } from 'src/app/vendors/vendor-report/vendor-report.component';
import { CompanyModel } from 'src/consts/common.model';
import { httpRoutes, httpVersion } from 'src/consts/http-routes';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { WEB_ROUTES } from 'src/consts/routes';
import { showNotification } from 'src/consts/utils';

@Component({
  selector: 'app-switch-company',
  templateUrl: './switch-company.component.html',
  styleUrls: ['./switch-company.component.scss'],
  imports: [MatIconModule, CommonModule,
    FormsModule,
    ReactiveFormsModule,   // ✅ Needed for [formGroup]
    MatChipsModule,        // ✅ Needed for <mat-chip removable>
    MatIconModule,         // ✅ Needed if you use <mat-icon> inside chip
    MatFormFieldModule,    // ✅ Needed for <mat-form-field> and <mat-label>
    MatInputModule,        // ✅ Needed for <input matInput>
    MatButtonModule,
    NgScrollbarModule,
    CommonComponentsModule,
    LoadingComponent,
    ModelHeaderComponent
  ]
})
export class SwitchCompanyComponent implements OnInit {
  companyList: Array<CompanyModel> = [];
  companyCode = '';
  isLoading = true;
  form!: UntypedFormGroup;
  hide = true;
  showCompanyList = true;
  selectedCompany!: CompanyModel;
  removable = true;
  title = 'Choose Organization';

  constructor(public dialogRef: MatDialogRef<SwitchCompanyComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private commonService: CommonService, private snackBar: MatSnackBar, private router: Router, public uiSpinner: UiSpinnerService,
    private formBuilder: FormBuilder, private authenticationService: AuthenticationService) {
    this.form = this.formBuilder.group({
      password: ["", Validators.required],
    });
  }

  async ngOnInit() {
    const user_data = localStorage.getItem(localStorageConstants.USERDATA) ?? '';
    if (user_data !== '') {

      const userData = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA) ?? '{}');
      this.companyCode = userData.companydata.companycode;
      const requestObject = {
        useremail: userData.UserData.useremail
      };
      const encryptedData = this.authenticationService.encription(requestObject);
      const hex = this.authenticationService.getHex();
      const data = await this.commonService.postRequestAPI(httpVersion.V1 + httpRoutes.GET_MY_COMPANY_LIST, { encryptedData, iv: hex });
      this.isLoading = false;
      if (data.status) {
        this.companyList = data.data;
      }
    } else {
      this.isLoading = false;
    }
  }

  selectCompany(company: CompanyModel) {
    if (this.companyCode === company.companycode) {
      showNotification(this.snackBar, 'You are already logged-in company.', 'error');
    } else {
      this.showCompanyList = false;
      this.selectedCompany = company;
    }
  }

  removeCompany() {
    this.showCompanyList = true;
  }

  async userLogin() {
    if (this.form.valid) {
      this.uiSpinner.spin$.next(true);
      const userData = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA) ?? '{}');

      const formValues = this.form.value;
      formValues.useremail = userData.UserData.useremail;
      formValues.companycode = this.selectedCompany.companycode;
      const encryptedData = this.authenticationService.encription(formValues);
      const hex = this.authenticationService.getHex();
      const data = await this.commonService.postRequestAPI(httpVersion.V1 + httpRoutes.USER_LOGIN, { encryptedData, iv: hex });
      this.uiSpinner.spin$.next(false);
      if (data.status) {
        this.dialogRef.close();
        showNotification(this.snackBar, data.message, 'success');
        this.authenticationService.changeTokenValue(data.data.token);
        localStorage.setItem(localStorageConstants.INVOICE_TOKEN, data.data.token);
        localStorage.setItem(localStorageConstants.COMPANYID, data.data.companydata._id);
        localStorage.setItem(localStorageConstants.USERDATA, JSON.stringify(data.data));

        if (data.data.UserData.useris_password_temp == true) {
          // this.router.navigate([WEB_ROUTES.FORCEFULLY_CHANGE_PASSWORD]);
          setTimeout(() => {
            location.reload();
          }, 200);
        } else {
          if (window.location.pathname === WEB_ROUTES.DASHBOARD) {
            setTimeout(() => {
              location.reload();
            }, 200);
          } else {
            this.router.navigate([WEB_ROUTES.DASHBOARD]);
            setTimeout(() => {
              location.reload();
            }, 200);
          }
        }

      } else {
        showNotification(this.snackBar, data.message, 'error');
      }
    }
  }
}
